module.exports = new __parcel__URL__("generic-empty-state-darkmode.27f5dcf1.svg").toString();